import ShippingProgress from './shippingProgress';
import styles from './packageStatus.module.css';
import TrackTraceState from './trackTraceState';
import {
    Icon,
    IconSizes,
    Icons,
    InfoDialog,
    Link,
    Typography,
} from '@toppy-webshop/toppy-design-system';
import {MutableRefObject, useRef} from 'react';
import {Shipment} from '../../models/shipment';
import {DeliveredAt, TrackTrace} from '../../models/trackTrace';
import calculateShipmentTrackProgress from '../../helpers/calculateShipmentTrackProgress';
import ShipmentState from './shipmentState';
import {useI18nContext} from '../../i18n/i18n-react';
import getTrackingInformation from '../../utils/getTrackingInformation';
import {TranslationFunctions} from '../../i18n/i18n-types';

interface PackageStatusProps {
    shipment: Shipment;
}

const render = (
    shipment: Shipment,
    trackTrace: TrackTrace | null,
    dialogRefs: MutableRefObject<{[key: string]: HTMLDialogElement | null}>,
    LL: TranslationFunctions
) => {
    const [title, description] = getTrackingInformation(
        shipment,
        trackTrace,
        LL
    );
    const key = trackTrace ? `track_${trackTrace.id}` : `track_${shipment.id}`;

    return (
        <div key={key}>
            <div className={styles['info-wrapper']}>
                <span className={styles['description-wrapper']}>
                    <span className={styles.description}>
                        <Typography size={'s'} weight={'bold'}>
                            {title}
                        </Typography>
                    </span>

                    <Link onClick={() => dialogRefs.current[key]?.showModal()}>
                        <Icon
                            icon={Icons.INFO_BOX_FULL}
                            color="blue"
                            size={IconSizes.S}
                        />
                    </Link>

                    <InfoDialog
                        ref={el => {
                            dialogRefs.current[key] = el;
                        }}
                        onClose={() => {
                            dialogRefs.current[key]?.open &&
                                dialogRefs.current[key] &&
                                dialogRefs.current[key]?.close();
                        }}
                        title={'Wat dat betekend?'}
                        buttonText={LL.menu.close()}
                        buttonType={'outline'}
                        content={description}
                    />
                </span>
                <div className={styles['delivery-time']}>
                    {!trackTrace && (
                        <ShipmentState deliveryDate={shipment.deliveryDate} />
                    )}
                    {trackTrace && (
                        <TrackTraceState
                            trackTrace={trackTrace}
                            deliveryDate={shipment.deliveryDate}
                        />
                    )}
                </div>
            </div>
            <ShippingProgress
                hasPackages={true}
                trackProgress={calculateShipmentTrackProgress(
                    shipment,
                    trackTrace
                )}
                isDeliveredElsewhere={
                    (trackTrace &&
                        trackTrace.deliveredAt !== null &&
                        trackTrace.deliveredAt !== DeliveredAt.HOME) as boolean
                }
                isDelivered={(trackTrace && trackTrace.isDelivered) as boolean}
            />
        </div>
    );
};

const ShipmentTracking = ({shipment}: PackageStatusProps) => {
    const {LL} = useI18nContext();
    const dialogRefs = useRef<{[key: string]: HTMLDialogElement | null}>({});

    if (!shipment.tracks.length) {
        return render(shipment, null, dialogRefs, LL);
    }

    return (
        <>
            {shipment.tracks.map((trackTrace, key) =>
                render(shipment, trackTrace, dialogRefs, LL)
            )}
        </>
    );
};

export default ShipmentTracking;
